import { Col, Row } from 'antd'
import Logo from 'src/assets/images/LOGO-02.png'
import { Icon } from 'src/components/common/icons'
import IconFacebook from 'src/assets/images/IconFaceBook.svg'
import IconYoutube from 'src/assets/images/IconYoutube.svg'
import IconTiktok from 'src/assets/images/IconTiktok.svg'

function Footer() {
  return (
    <footer
      className="p-12 pb-6 mt-20 max-w-[1200px] mx-auto"
      style={{ backgroundColor: 'rgba(2, 2, 2, 0.45)' }}
    >
      <img src={Logo} className="max-w-[175px] w-full" alt="" />
      <Row className="mt-8" gutter={[24, 24]}>
        <Col lg={8} xs={24} className="pr-2">
          <h4 className="text-xl">VỀ CHÚNG TÔI</h4>
          <p className="mt-4">
            Công ty TNHH Dịch vụ và Giải trí Sắc Việt hiện đang là đơn vị tổ
            chức các chương trình biểu diễn nghệ thuật chuyên nghiệp tại Việt
            Nam, trong đó có chuỗi chương trình MELODY SHOW
          </p>
          <p className="mt-4"></p>
          <p className="mt-4">
            Trụ sở văn phòng: Số 73 đường Tuệ Tĩnh, xã Ninh Tiến, Thành phố Hoa
            Lư, Tỉnh Ninh Bình
          </p>
        </Col>
        <Col lg={8} xs={24} className="pr-2">
          <h4 className="text-xl">LIÊN HỆ VỚI CHÚNG TÔI</h4>
          <h4 className="text-md mt-2">
            CÔNG TY TNHH DỊCH VỤ VÀ GIẢI TRÍ SẮC VIỆT
          </h4>
          <p className="mt-2">Hotline:</p>
          <p className="flex text-[16px] leading-[26px] mt-1">
            <Icon name="phone" className="mr-4 w-[17px]" />
            <span>0918222135</span>
          </p>
          <p className="flex text-[16px] leading-[26px] mt-1 ml-8">
            <span>02293580888</span>
          </p>
          <p className="mt-4">
            MST: <span>2700837492</span>
          </p>
          <p className="mt-4">Email:</p>
          <p className="flex text-[16px] leading-[26px] mt-1">
            <Icon name="email" className="mr-4 w-[17px]" />
            <span>Tochucsukiensacviet@gmail.com</span>
          </p>
          <p className="mt-4">
            Văn phòng: <span></span>
          </p>
          <p className="flex text-[16px] mt-1">
            <Icon name="direction" className="mr-4 w-[17px]" />
            <span>
              Số 73 đường Tuệ Tĩnh, xã Ninh Tiến, Thành phố Hoa Lư, Tỉnh Ninh
              Bình
            </span>
          </p>
        </Col>
        <Col lg={8} xs={24} className="pr-2">
          <h4 className="text-xl">TRUY CẬP NHANH</h4>
          <a
            href="/huong-dan-thanh-toan-vnpay-tren-website"
            target="_blank"
            className="block mt-2 border-b border-solid border-[#fff] pb-2"
          >
            Hướng dẫn thanh toán VNPay
          </a>
          <a
            href="/chinh-sach-va-dieu-khoan"
            target="_blank"
            className="block mt-2 border-b border-solid border-[#fff] pb-2"
          >
            Chính sách và điều khoản
          </a>
          <a
            href="/"
            target="_blank"
            className="block mt-2 border-b border-solid border-[#fff] pb-2"
          >
            Khám phá âm nhạc
          </a>
          <h4 className="mt-4">Follow US</h4>
          <div className="flex mt-4">
            <a href="https://www.facebook.com/sacvietmelody" target="_blank">
              <img className="mr-4" src={IconFacebook} alt="Facebook" />
            </a>
            <a href="https://www.youtube.com/@SacViet.Melody" target="_blank">
              <img
                width={40}
                height={40}
                className="mr-4"
                src={IconYoutube}
                alt="Youtube"
              />
            </a>
            <a href="https://www.tiktok.com/@sacvietmelody" target="_blank">
              <img src={IconTiktok} alt="Tiktok" />
            </a>
          </div>
        </Col>
        {/* <Col lg={6} xs={24} className="pr-2">
          
        </Col> */}
        <div className="w-full mt-4 pt-4 border-t border-solid border-[#fff]">
          <h6 className="text-center">BẢN QUYỀN BỞI SẮC VIỆT EVENT</h6>
        </div>
      </Row>
    </footer>
  )
}

export default Footer
